var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 5.14286C36 2.30143 33.6986 0 30.8571 0H5.14286C2.30143 0 0 2.30143 0 5.14286V30.8571C0 33.6986 2.30143 36 5.14286 36H30.8571C33.6986 36 36 33.6986 36 30.8571V5.14286Z",
    fill: "#050505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11633 28.4656H9.68776L16.5535 20.6613L22.5256 28.4528H29.507L20.3463 16.3413L28.0992 7.53418H25.5278L19.157 14.7728L13.6928 7.54061H6.48633L15.3513 19.1056L7.1099 28.472L7.11633 28.4656ZM10.4013 9.46275H12.7413L25.637 26.5242H23.4835L10.4078 9.46275H10.4013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterx);
export default __webpack_public_path__ + "static/media/twitterx.2f2f40f43d2218e9724ddccf4e702232.svg";
export { ForwardRef as ReactComponent };